/**
 * GetFormattedTime
 *
 * Returns the formatted time for a given time.
 * If no time is provided, it uses the default which is 19:00
 *
 * @return {function}
 */

OT.createNS('OT.Search.Helpers.getFormattedTime');

OT.Search.Helpers.getFormattedTime = function(time) {

    if (!time) {
        var timeFormat = Resources.Strings.TimeFormatJS;
        
        time = OT.Search.Helpers.RoundTimeTo.halfHour(moment().format(timeFormat));

        // JC 16/01/14: Ben rounded the time to halfHour if UK and quarterHour if anywhere else, mimiking the existing functionality.
        // The new search is 30 minute timeslots for now, so remove this if else if it's still not needed after a reasonable period of time.
        
        // if (Resources.Strings.GoogleMaps_Region === 'uk') {
        //     time = OT.Search.Helpers.RoundTimeTo.halfHour(moment().format(timeFormat));	
        // } else {
        //     time = OT.Search.Helpers.RoundTimeTo.quarterHour(moment().format(timeFormat));
        // }
    }

    return time;

};